import { getYear } from 'date-fns';

import { PageNavigationItem } from '../../components/Navigation/PageNavigation/PageNavigation';
import { GetSingleSpecies_entry_exampleCatchWithImage } from '../../interfaces/graphql';

export function getSubNavLinks({
  hasCatches,
  hasTips,
}: {
  hasCatches: boolean;
  hasTips: boolean;
}): PageNavigationItem[] {
  return [
    { id: 'details-section', label: 'Details' },
    // We can't explicitly check for the existence of baits as they're loaded on demand, but
    // having catches is a good proxy
    ...(hasCatches ? [{ id: 'top-baits-section', label: 'Top baits' }] : []),
    ...(hasTips ? [{ id: 'tips-section', label: 'Pro tips' }] : []),
    ...(hasCatches ? [{ id: 'nearby-waters-section', label: 'Nearby waters' }] : []),
    ...(hasCatches ? [{ id: 'catches-section', label: 'Catches' }] : []),
    // We are not currently listing blog posts (query happening inside component)
    { id: 'other-species-section', label: 'Nearby species' },
  ];
}

export function getImageTitle({
  post: {
    user: { isPremium, nickname, createdAt },
  },
}: GetSingleSpecies_entry_exampleCatchWithImage): string {
  return `${nickname}, Fishbrain ${isPremium ? 'Pro ' : ''}angler since ${getYear(
    new Date(createdAt),
  )}`;
}
